import React, { useId } from "react";
import { concatClassnames } from "shared/utils/concatClassnames";
import Icon, { IconTypes } from "../icon";

interface LabelProps {
  htmlFor: string;
  className?: string;
  required?: boolean;
  bold?: boolean;
  children: any;
  showInfoButton?: boolean;
  onInfoButtonClick?: () => void;
}

const Label: React.FC<LabelProps> = ({
  className,
  htmlFor,
  children,
  required = false,
  bold,
  showInfoButton = false,
  onInfoButtonClick = () => {},
}) => {
  const labelId = useId();
  const infoId = useId();
  return (
    <div
      className={concatClassnames(bold && "gg-font-bold", "gg-flex", className)}
    >
      <label id={labelId} htmlFor={htmlFor}>
        {children}
        {required && <span className="gg-ml-1 gg-text-lg gg-text-red">*</span>}
      </label>

      {showInfoButton && (
        <button
          type="button"
          aria-labelledby={`${infoId} ${labelId}`}
          onClick={onInfoButtonClick}
          data-testid="option-info-button"
          className="gg-shrink-0 gg-cursor-pointer"
        >
          <span id={infoId} className="gg-sr-only">
            Meer informatie over
          </span>
          <Icon name={IconTypes.INFO} className="gg-ml-2" alt="" />
        </button>
      )}
    </div>
  );
};

export default Label;
